import { Accordion } from './accordion';

const init = () => {
    const groups = document.querySelectorAll('[data-accordion-allow-all-closed]');
    if (!groups.length) return;

    // Create an instance for each accordion group
    Array.from(groups).map((group) => new Accordion(group));
};

export default init;
